module.exports = __webpack_public_path__ + "static/media/eduction_btm_3.a1a90752.png";